import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Box, Button, Chip, Grid, Paper, Typography } from "@mui/material";
import { Moment } from "moment";
import React, { useState } from "react";
import LoadingApiQuery from "../LoadingApiQuery";

export default function Calendario({
    diaSelecionado,
    actionsButtons = [],
    chipCalendario,
    isFetching = false,
    alterarDiaSelecionado
}: CalendarioProps) {

    const [openModalDate, setOpenModalDate] = useState(false)

    const inicioMes = diaSelecionado.clone().startOf('month');
    const fimMes = diaSelecionado.clone().endOf('month');

    const primeiroDiaSemana = inicioMes.weekday();

    const dias: Moment[] = [];

    let day = inicioMes.clone().subtract(primeiroDiaSemana, 'days');
    while (day.isBefore(inicioMes)) {
        dias.push(day.clone());
        day.add(1, 'day');
    }

    day = inicioMes.clone();
    while (day <= fimMes) {
        dias.push(day.clone());
        day.add(1, 'day');
    }

    day = fimMes.clone().add(1, 'day');
    while (day.weekday() !== 0) {
        dias.push(day.clone());
        day.add(1, 'day');
    }


    const handleNextMonth = () => {
        alterarDiaSelecionado(diaSelecionado.clone().add(1, 'month'));
    };

    const handlePreviousMonth = () => {
        alterarDiaSelecionado(diaSelecionado.clone().subtract(1, 'month'));
    };

    return (
        <>
            <Paper
                elevation={2}
            >
                <Box display={'flex'} justifyContent={'space-between'} p={3}>
                    <Box display={'flex'} alignItems={'center'}>
                        <Button
                            color='inherit'
                            size="small"
                            onClick={handlePreviousMonth}
                        >
                            <KeyboardArrowLeft />
                        </Button>

                        <Typography
                            component={'data'}
                            bgcolor={'transparent'}
                            border={'unset'} variant="h6"
                            fontWeight={'bold'}
                            onClick={() => setOpenModalDate(true)}
                            sx={{ cursor: 'pointer' }}
                        >
                            {diaSelecionado.format('MMMM/YYYY').toUpperCase()}
                        </Typography>


                        <Button color='inherit'
                            size="small"
                            onClick={handleNextMonth}
                        >
                            <KeyboardArrowRight />
                        </Button>
                    </Box>
                    <Box>
                        {
                            actionsButtons && actionsButtons.length > 0 &&
                            <Box display={'flex'} flexDirection={'column'} >
                                <Typography variant="subtitle1">Ações:</Typography>
                                <Box display={'flex'} gap={2}>
                                    {
                                        actionsButtons.map((action, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    {action.button}
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </Box>
                            </Box>
                        }
                    </Box>
                </Box>

                {
                    isFetching &&
                    <LoadingApiQuery size={60} extraParams={{ height: 830, alignItems: 'center' }} />
                }

                {!isFetching &&
                    <Grid container sx={{ height: '100%' }}>
                        {
                            ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map((diaSemana) => (
                                <Grid size={{ xs: 12 / 7 }} padding={0} key={diaSemana}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{
                                            height: '3vh',
                                        }}
                                    >
                                        <Typography variant="body1" fontWeight="bold">
                                            {diaSemana}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))
                        }
                        {
                            dias.map((day) => (
                                <Grid
                                    size={{ xs: 12 / 7 }}
                                    padding={0}
                                    key={day.format('YYYY-MM-DD')}
                                    onClick={() => {
                                        alterarDiaSelecionado(day)
                                    }}
                                >
                                    <Box
                                        sx={{
                                            height: '160px',
                                            padding: 1,
                                            cursor: 'pointer',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            borderRadius: 'unset',
                                            border: '1px solid #ccc',
                                            outline: day.isSame(diaSelecionado, 'day') ? '2px solid #1B5E20' : 'none',
                                            outlineOffset: '-2px',
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            color={day.weekday() === 0 ? '#ccc' : 'textPrimary'}
                                        >
                                            {day.format('D')}
                                        </Typography>

                                        <Box sx={{}} display={'flex'} flexDirection={'column'}>
                                            {(chipCalendario[day.format('YYYY-MM-DD')] || []).map((chip, index) => (
                                                <Chip
                                                    key={index}
                                                    size="small"
                                                    sx={{ marginBottom: 0.5 }}
                                                    label={chip.label}
                                                    icon={chip.icon}
                                                    onClick={() => chip.action(chip.id)}
                                                />
                                            ))}
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                    </Grid>
                }
            </Paper>
        </>
    )
}
interface CalendarioProps {
    diaSelecionado: Moment
    alterarDiaSelecionado: (data: Moment) => void
    actionsButtons?: CalendarioActions
    chipCalendario: ChipCalendario
    isFetching?: boolean
}

export type CalendarioActions = Array<{
    button: JSX.Element
}>
export interface ChipCalendario {
    [date: string]: ChipProps[]
}

type ChipProps = {
    label: string;
    id: number;
    icon?: JSX.Element;
    action: (id: number) => void;
}
